<div [formGroup]="form"> 
  <div class="row" [ngClass]="{'disabled': (searchStatus == 1 || loadModel == 1 || loadMakes === 1)  }">
    <div class="form-group col-6">
      <label for="licensePlateNumber" class="d-block">Patente</label>
      <div class="col-10 pl-0 pr-1" style="display: inline-block;">
        <input #search
          type="text"
          customFocus
          name="licensePlateNumber"
          formControlName="licensePlate"
          class="form-control"
          id="licensePlateNumber"
          autocorrect="off"
          autocapitalize="off"
          (click)="_errorMessage = ''"
          spellcheck="off"
          [placeholder]="'Buscar patente'"
          (keydown.enter)="licenseChange()"
          cnm-clear-input 
          [clearVisible]='true' 
          (onClear)="onClickclearText()"
          (ngModelChange)="licenseChange()">
      </div>
      <button id="add-group-btn" 
        type="button" 
        class="btn btn-primary col-2 align-self-center align-bottom" 
        [tooltip]="'Consultar Patente'" 
        [disabled]="!licensePlate.value || licensePlate.value.length < 6"
        (click)="onLicenseSearch(licensePlate.value, true); _errorMessage = ''">
        <span *ngIf="searchStatusBtn != 1"> <i class="fa-solid fa-magnifying-glass"></i></span>
        <span *ngIf="searchStatusBtn === 1"><i class="fas fa-circle-notch fa-spin"></i></span>
      </button>
    </div>
    <div class="form-group col-6" >
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Marca'"
        [bordered]="true"
        [isDisabled]="isDisabled"
        (click)="_errorMessage = ''"
        name="vehicleMakes"
        id="vehicleMakes"
        formControlName="vehicleMakes"
        [(sourceList)]="_vehicleMakesList"
        (select)=" this.getModelsByMakeID(vehicleMakes?.value?.value, _data);"
        [required]="!vehicleMakes?.value?.value?true:false">
      </custom-select>
    </div>
    <div class="form-group col-4" *ngIf="_vehicleModelList?.length">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Modelo'"
        [bordered]="true"
        (click)="_errorMessage = ''"
        [isDisabled]="isDisabled"
        name="vehicleModel"
        id="vehicleModel"
        formControlName="vehicleModel"
        [(sourceList)]="_vehicleModelList"
        (select)="getVehiclesTypes(_data);"
        [required]="!vehicleModel?.value?.value?true:false">
      </custom-select>
    </div>
    <div class="form-group col-4" *ngIf="!_vehicleModelList?.length && vehicleMakes?.value?.value">
      <label for="vehicleModel" class="text-truncate" style="max-width: 100%;">Modelo</label>
      <input type="text" 
        maxlength="255"
        name="vehicleModel"
        formControlName="vehicleModel"
        (click)="_errorMessage = ''"
        class="form-control" 
        id="vehicleModel" 
        [placeholder]="'Modelo'"
        [required]="licensePlate.value ? true : false">
    </div>
    <div class="form-group col-4">
      <custom-select
      [filterEnabled]="true"
      [labelText]="'Color'"
      [bordered]="true"
      (click)="_errorMessage = ''"
      name="vehicleColor"
      id="vehicleColor"
      formControlName="vehicleColor"
      [(sourceList)]="_vehicleColorList"
      (select)="updateVehicleColor()"
      [required]="!vehicleColor?.value?.value?true:false"
      ></custom-select>
    </div>
    <div class="form-group col-4">
      <label for="vehicleYear">Año</label>
      <input type="tel"
      class="form-control"
      id="vehicleYear"
      name="vehicleYear"
      formControlName="vehicleYear"
      (click)="_errorMessage = ''"
      minlength="4"
      maxlength="4"
      [customMax]="currentYear"
      (keypress)="($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode < 58) || $event.charCode == 45)"
      lang="en"/>
    </div>
    <div class="form-group col-4">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Tipo'"
        [bordered]="true"
        (click)="_errorMessage = ''"
        [isDisabled]="isDisabled"
        name="vehicleType"
        id="vehicleType"
        formControlName="vehicleType"
        [(sourceList)]="_vehicleTypeList"
        required>
      </custom-select>
    </div>
    <div class="form-group col-4" >
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Aseguradora'"
        [bordered]="true"
        [rememberCheck]="true"
        (rememberDataEmit)="saveInsurance($event)"
        (click)="_errorMessage = ''"
        name="insuranceCompany"
        id="insuranceCompany"
        formControlName="insuranceCompany"
        [(sourceList)]="_insuranceCompanyList">
      </custom-select>
    </div>
    <div class="form-group col-4">
      <label for="insurancePolicy">Póliza de seguro</label>
      <input
        type="text" 
        maxlength="255"
        name="insurancePolicy"
        (click)="_errorMessage = ''"
        formControlName="insurancePolicy"
        class="form-control" 
        id="insurancePolicy" 
        [placeholder]="'Póliza de seguro'">
    </div>
    <div class="form-group col-4">
      <lib-datepicker
      [labelText]="'Fecha de vigencia desde'"
      name="dateFromInsurance"
      id="dateFromInsurance"
      [useTime]="true"
      [defaultToday]="false"
      (click)="_errorMessage = ''"
      [disabledFutureDates]="true"
      formControlName="dateFromInsurance"
      [placeholder] ="'Fecha de vigencia Desde'"
      (ngModelChange)="onDateChange('dateFromInsurance')"
      [maxDate]="today"
      [required]="false"
      ></lib-datepicker>
    </div>
    <div class="form-group col-4">
      <lib-datepicker
      [labelText]="'Fecha de vigencia Hasta'"
      name="dateToInsurance"
      id="dateToInsurance"
      [defaultToday]="false"
      (click)="_errorMessage = ''"
      [disabledFutureDates]="false"
      [useTime]="true"
      formControlName="dateToInsurance"
      [placeholder] ="'Fecha de vigencia Hasta'"
      (ngModelChange)="onDateChange('dateToInsurance')"
      [minDate]="minDateInsurance"
      [required]="false"
      ></lib-datepicker>
    </div>
    <div class="form-group col-4">
      <label for="assistance">Asistencia</label>
      <custom-select
      [filterEnabled]="true"
      [bordered]="true"
      (click)="_errorMessage = ''"
      name="assistance"
      id="assistance"
      formControlName="assistance"
      [(sourceList)]="_assistanceList"
      required
      ></custom-select>
    </div>
    <div class="col-12" >
      <div class="col-12 pr-4 alert alert-warning alert-dismissible fade show d-flex justify-content-between align-items-center" role="alert" *ngIf="!warningExpiration">
        <p class="mb-0"><strong>Aviso!</strong>: El SOAP de este vehículo se encuentra caducado.</p>
        <button type="button" class="btn btn-warning ml-3" data-dismiss="alert" aria-label="Close" (click)="warningExpiration = true">OK</button>
      </div>
    </div>
    <div class="form-group col-2 d-flex align-items-center">
      <div class="custom-control custom-checkbox mt-2">
        <input
          formControlName="transfer"
          (click)="_errorMessage = ''"
          type="checkbox"
          [name]="editing ? 'transfer'+'-editing' : 'transfer'"
          [id]="editing ? 'transfer' +'-editing' : 'transfer'"
          class="custom-control-input"/>
        <label class="custom-control-label" [for]="editing ? 'transfer' +'-editing' : 'transfer'">Traslado</label>
      </div>
    </div>
    <div class="form-group col-5">
      <custom-select
      [filterEnabled]="true"
      [labelText]="'Trasladado por'"
      [bordered]="true"
      [isDisabled]="!transfer.value"
      (click)="_errorMessage = ''"
      name="transferResponsible"
      id="transferResponsible"
      formControlName="transferResponsible"
      [(sourceList)]="_transferResponsibleList"
      ></custom-select>
    </div>
    <div class="form-group col-5">
      <label for="vehicleDestination">Destino</label>
      <input
        type="text" 
        maxlength="255"
        name="vehicleDestination"
        formControlName="vehicleDestination"
        (click)="_errorMessage = ''"
        class="form-control" 
        id="vehicleDestination" 
        [placeholder]="'Destino traslado'">
    </div>
  </div>

  <div class="row mx-0 my-3 p-3" style="border: 1px solid #b9afaf8f;border-radius: 10px;"  [ngClass]="{'disabled': (searchStatus == 1 || loadModel == 1 || loadMakes === 1)  }">
    <p class="d-block w-100"><strong>Datos del titular</strong></p>
    <div class="form-group col-3 pr-1 pl-0" >
      <label for="documentType" class="text-truncate" style="max-width: 100%;">Tipo de documento</label>
      <custom-select
        [filterEnabled]="true"
        [isDisabled]="documentDisabled"
        [bordered]="true"
        name="documentType"
        id="documentType"
        formControlName="documentType"
        (click)="_errorMessage = ''"
        [(sourceList)]="_documentTypeList">
      </custom-select>
    </div>
    <div class="form-group col-3 px-1">
      <label [for]="'documentNumber'" class="text-truncate" style="max-width: 100%;">N° de documento</label>
      <input type="tel"
      class="form-control"
      [id]="'documentNumber'"
      [name]="'documentNumber'"
      formControlName="documentNumber"
      (click)="_errorMessage = ''"
      minlength="4"
      (keypress)="(documentType?.value?.value === 4 ? ($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode < 58) || $event.charCode == 45) : true)"
      lang="en"/>
    </div>
    <div class="form-group col-3 pl-1 pr-0">
      <label for="name" class="text-truncate" style="max-width: 100%;">Nombre</label>
      <input type="text" 
        maxlength="255"
        name="name"
        formControlName="name"
        (click)="_errorMessage = ''"
        class="form-control" 
        id="name" 
        [placeholder]="'Nombre'"
        (ngModelChange)="updatePersonFullName(name.value, lastName.value)"
        [required]="documentNumber.value?true:false">
    </div>
    <div class="form-group col-3 pl-1 pr-0">
      <label for="lastName" class="text-truncate" style="max-width: 100%;">Apellido</label>
      <input type="text" 
        maxlength="255"
        name="lastName"
        formControlName="lastName"
        (click)="_errorMessage = ''"
        class="form-control" 
        id="lastName" 
        [placeholder]="'Apellido'"
        (ngModelChange)="updatePersonFullName(name.value, lastName.value)"
        [required]="documentNumber.value?true:false">
    </div>
    <div class="form-group col-auto pl-0 d-flex align-items-center">
      <div class="custom-control custom-checkbox mt-2">
        <input
          formControlName="personPresent"
          (click)="_errorMessage = ''"
          type="checkbox"
          [name]="editing ? 'personPresent'+'-editing' : 'personPresent'"
          [id]="editing ? 'personPresent' +'-editing' : 'personPresent'"
          class="custom-control-input"/>
        <label class="custom-control-label" [for]="editing ? 'personPresent' +'-editing' : 'personPresent'">Presente en el vehículo</label>
      </div>
    </div>
    <div class="form-group col-7 pr-0" [ngClass]="{'d-flex': personType?.value?.label === 'Otro' || personType?.value?.label === 'Other'}" *ngIf="personPresent.value">
      <div class="col-6" [ngClass]="{'pl-0 pr-1': personType?.value?.label === 'Otro' || personType?.value?.label === 'Other', 'px-0': (personType?.value?.label !== 'Otro') }">
        <label for="personType" class="text-truncate" style="max-width: 100%;">Tipo de persona</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="personType"
          id="personType"
          formControlName="personType"
          (click)="_errorMessage = ''"
          [(sourceList)]="_personTypeList">
        </custom-select>
      </div>
      <!-- <div class="form-group col-6 px-0" *ngIf="personType?.value?.label === 'Otro' || personType?.value?.label === 'Other'">
        <label for="personDescription" class="text-truncate" style="max-width: 100%;">Descripción</label>
        <input type="text"
          class="form-control"
          formControlName="personDescription"
          id="personDescription"
          name="personDescription"
          required/>
      </div> -->
    </div>
  </div>
  <div class="alert alert-danger col-sm-12" *ngIf="_errorMessage">{{_errorMessage}}</div>
</div>
<div class="text-center my-3 not-found-data" *ngIf="(searchStatus == 1 || loadModel == 1 || loadMakes == 1)">
  <i class="fas fa-circle-notch fa-spin fa-3x"></i>
</div>
